module.exports = __webpack_public_path__ + "static/img/a096.03c0853.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a096.jpg
// module id = Ru1X
// module chunks = 0